<template>
  <form class="userForm" v-if="user || isAddUser">
    <form-group>
      <field name="Name" :value="user.name" v-model="user.name"/>
    </form-group>
    <form-group>
      <field name="Email" :value="user.email" type="email" v-model="user.email"/>
    </form-group>
    <form-group>
      <field name="Password" :value="user.password" type="password" v-model="user.password"/>
    </form-group>
    <form-group>
      <dropdown name="Role" :options="roles.options" :current="user.role" v-model="user.role"/>
    </form-group>
    <form-group>
      <label>Enable After Effects</label>
      <checkbox :name="is_ae_allowed" :value="user.isAeAllowed" v-model="user.isAeAllowed"/>
    </form-group>
    <form-group>
      <label>Enable Render Manager</label>
      <checkbox :name="is_rm_allowed" :value="user.is_rm_allowed" v-model="user.is_rm_allowed"/>
    </form-group>
    <form-group v-if="!isAddUser">
      <label>Active</label>
      <checkbox :name="is_active" :value="user.is_active" v-model="user.is_active"/>
    </form-group>
    <form-group>
      <label>FTP Transfer Allowed</label>
      <checkbox :name="ftp_allowed" :value="user.ftp_allowed" v-model="user.ftp_allowed"/>
    </form-group>
    <form-group>
      <field name="Bucket" :value="user.bucket" type="text" v-model="user.bucket"/>
    </form-group>
    <heading type="h2">Manage Clients</heading>
    <list v-model="user.clients" :data="this.clients" :currentIds="user.clients" />
    <form-group>
      <button-cta :onClick="submit">Save</button-cta>
    </form-group>
  </form>
</template>

<script>
import FormGroup from '@/components/Form/FormGroup/form-group'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import Field from '@/components/Form/Field/field'
import RadioButton from '@/components/Form/RadioButton/radio-button'
import ButtonCta from '@/components/Button/button'
import Heading from '@/components/Heading/heading'
import List from '@/components/List/list'
import {clientMixin} from '@/mixins/clientMixin'
import {modalMixin} from '@/mixins/modalMixin'
import Checkbox from '../Form/Checkbox/checkbox'

export default {
  name: 'UserForm',
  mixins: [clientMixin, modalMixin],
  components: {
    Checkbox,
    FormGroup,
    Dropdown,
    Field,
    RadioButton,
    ButtonCta,
    Heading,
    List
  },
  props: {
    user: Object,
    submit: Function,
    isAddUser: Boolean
  },
  created () {
    this.getClients().then(() => {
      this.$emit('loading', false)
      this.finishLoading()
    })
  },
  data: () => ({
    roles: {
      options: [
        {
          name: 'Admin',
          value: 1
        },
        {
          name: 'Editor',
          value: 2
        },
        {
          name: 'Render Bot',
          value: 3
        },
        {
          name: 'Client Admin',
          value: 4
        },
        {
          name: 'Role Publisher',
          value: 5
        },
        {
          name: 'Local User',
          value: 6
        }
      ]
    }
  })
}
</script>

<style lang="scss">
    @import "./user-form";
</style>



// WEBPACK FOOTER //
// src/components/UserForm/user-form.vue